var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.id,staticClass:"Dropzone",class:_vm.color,attrs:{"id":_vm.id}},[(_vm.color=='none')?_c('div',{staticClass:"Dropzone__question"},[_vm._v("?")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }